document.addEventListener('variant:changed', function (event) {
    try {
        /*********************************
         SAFE GET HELPERS
         *********************************/
        const safeGet = (fn, fallback = null) => {
            try {
                return fn();
            } catch (err) {
                console.warn('SafeGet error:', err);
                return fallback;
            }
        };

        /*********************************
         GET VARIANT ID
         *********************************/
        const variantId = event?.detail?.variant?.id;

        if (!variantId) {
            console.warn('Variant ID not found');
            return;
        }

        /*********************************
         FIND VARIANT
         *********************************/
        const variant = window.productJson?.variants?.find(
            item => item.id == variantId
        );

        if (!variant) {
            console.warn('Variant not found in productJson');
            return;
        }

        /*********************************
         CHECK IMAGE DIV
         *********************************/
        if (!variant.image_div) {
            console.warn('Variant image_div missing');
            return;
        }

        /*********************************
         FIND CURRENT GALLERY
         *********************************/
        const currentGallery = document.querySelector('.productV11Visual');

        if (!currentGallery) {
            console.warn('Current gallery not found');
            return;
        }

        /*********************************
         DESTROY EXISTING SWIPER SAFELY
         *********************************/
        try {
            const swiperInstance =
                currentGallery.querySelector('.productV11VisualSwiper')?.swiper;

            if (swiperInstance && typeof swiperInstance.destroy === 'function') {
                swiperInstance.destroy(true, true);
            }
        } catch (err) {
            console.warn('Swiper destroy failed:', err);
        }

        /*********************************
         CREATE NEW GALLERY SAFELY
         *********************************/
        let newGallery;

        if (variant.image_div.includes("<img")) {
            try {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = variant.image_div;
                newGallery = tempDiv.firstElementChild;
            } catch (err) {
                console.warn('Gallery creation failed:', err);
                return;
            }
        }


        if (!newGallery) {
            console.warn('New gallery is empty');
            return;
        }

        /*********************************
         REPLACE GALLERY
         *********************************/
        try {
            currentGallery.replaceWith(newGallery);
        } catch (err) {
            console.warn('Gallery replace failed:', err);
            return;
        }

        /*********************************
         INIT SWIPER SAFELY
         *********************************/
        let swiper;

        try {
            const swiperEl = newGallery.querySelector('.productV11VisualSwiper');

            if (!swiperEl) {
                console.warn('Swiper element not found');
                return;
            }

            swiper = new Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 40,

                navigation: {
                    nextEl: newGallery.querySelector('.productV11VisualNext'),
                    prevEl: newGallery.querySelector('.productV11VisualPrev'),
                },

                scrollbar: {
                    el: newGallery.querySelector('.productV11VisualScroll'),
                    draggable: true,
                },

                loop: true,
                autoHeight: true,

                on: {
                    slideChange: function () {
                        try {
                            newGallery
                                .querySelector('.productV11VisualThumbsSlide.active')
                                ?.setAttribute("aria-current", "false");
                            newGallery
                                .querySelector('.productV11VisualThumbsSlide.active')
                                ?.classList.remove('active');

                            const thumbs = newGallery.querySelectorAll(
                                '.productV11VisualThumbsSlide'
                            );

                            const activeThumb = thumbs?.[this.realIndex];

                            activeThumb?.classList.add('active');
                            activeThumb?.setAttribute("aria-current", "true");
                        } catch (err) {
                            console.warn('Slide change error:', err);
                        }
                    }
                }
            });
        } catch (err) {
            console.warn('Swiper init failed:', err);
        }

        /*********************************
         THUMB CLICK EVENTS
         *********************************/
        try {
            const thumbs = newGallery.querySelectorAll('.productV11VisualThumbsSlide');

            if (thumbs?.length) {
                thumbs.forEach((thumb) => {
                    thumb.addEventListener('click', function () {
                        try {
                            newGallery
                                .querySelector('.productV11VisualThumbsSlide.active')
                                ?.setAttribute("aria-current", "false");
                            newGallery
                                .querySelector('.productV11VisualThumbsSlide.active')
                                ?.classList.remove('active');

                            this.classList.add('active');
                            this.setAttribute("aria-current", "true");

                            swiper?.slideToLoop(
                                parseInt(this.dataset.index || 1) - 1
                            );
                        } catch (err) {
                            console.warn('Thumb click error:', err);
                        }
                    });
                });
            }
        } catch (err) {
            console.warn('Thumb binding failed:', err);
        }

        /*********************************
         UPDATE VARIANT TITLE
         *********************************/
        safeGet(() => {
            const titleEl = document.querySelector('.productV11Title');
            if (!titleEl) return;

            const flavorOptionIndex = Number(titleEl.dataset.flavorOptionIndex);
            if (flavorOptionIndex < 0) return;

            const flavor = variant.options?.[flavorOptionIndex] || '';
            const displayFlavor = titleEl.closest('[data-v12-main]')
                ? ({
                    'Peanut Butter & Dark': 'Peanut Butter & Dark Chocolate',
                    'Vanilla & Dark': 'Vanilla & Dark Chocolate'
                }[flavor] || flavor)
                : flavor;
            const titleBase = titleEl.dataset.titleBase || '';
            const fullTitle = displayFlavor === 'Fruit Lovers Bundle' || displayFlavor.toLowerCase().includes(titleBase.toLowerCase())
                ? displayFlavor
                : `${displayFlavor} ${titleBase}`.trim();

            titleEl.textContent = fullTitle;
            titleEl.dataset.title = flavor;
        });

        /*********************************
         UPDATE DESCRIPTION
         *********************************/
        safeGet(() => {
            const variantDesc = document.querySelector('.productV11Ingreds');
            if (variantDesc) {
                variantDesc.innerHTML =
                    variant?.metafields?.variant_description || '';
            }
        });

        /*********************************
         UPDATE BODY COLOR
         *********************************/
        safeGet(() => {
            const color =
                variant?.metafields?.variant_highlight_color;

            if (color) {
                document.documentElement.style.setProperty(
                    '--product-color',
                    color
                );
            }
        });

        /*********************************
         UPDATE BADGES
         *********************************/
        safeGet(() => updateOptionCards());

    } catch (err) {
        console.error('variant:changed fatal error:', err);
    }
});


(function () {

    const imageCache = new Map();
    const v12PackImageRequests = new WeakMap();

    function slugify(value) {
        return value
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/&/g, 'and')
            .replace(/[^a-z0-9]+/g, '_')
            .replace(/^_+|_+$/g, '');
    }

    async function getOptionImageUrl(fileName) {
        const extensions = ['webp', 'png'];

        for (const ext of extensions) {
            const imageUrl =
                `${window.location.origin}/cdn/shop/files/${fileName}.${ext}`;

            const exists = await loadImage(imageUrl);

            if (exists) {
                return imageUrl;
            }
        }

        return null;
    }

    function loadImage(url) {

        if (imageCache.has(url)) {
            return imageCache.get(url);
        }

        const promise = new Promise((resolve) => {

            const img = new Image();

            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);

            img.src = url;
        });

        imageCache.set(url, promise);

        return promise;
    }

    async function setOptionImage(imageContainer, imageUrl, alt, isCurrent = () => true) {

        const exists = await loadImage(imageUrl);
        if (!isCurrent()) return;

        if (!exists) {

            imageContainer.innerHTML = '';
            return;
        }

        const currentImage = imageContainer.querySelector('img');

        if (currentImage && currentImage.src.includes(imageUrl)) {
            return;
        }

        imageContainer.innerHTML = `
            <img
                src="${imageUrl}"
                alt="${alt}"
                loading="eager"
                width="100"
                height="100"
            >
        `;
    }

    async function updateOptionImages() {

        if (!window.productJson) {
            console.warn('window.productJson missing');
            return;
        }

        const productSlug = slugify(window.productJson.title);

        const optionGroups = document.querySelectorAll(
            '.productV11ControlsItem.option'
        );

        if (!optionGroups.length) {
            return;
        }

        const selectedValues = [];

        optionGroups.forEach((group) => {

            const checked = group.querySelector('input:checked');

            selectedValues.push(
                checked ? checked.value : null
            );
        });

        const updates = [];

        optionGroups.forEach((group, optionIndex) => {

            const labels = group.querySelectorAll(
                '.productV11ControlsItemChoicesLabel'
            );

            labels.forEach((label) => {

                const input = label.querySelector('input');

                if (!input) return;

                const imageContainer = label.querySelector(
                    '.productV11ControlsItemChoicesImage'
                );

                if (!imageContainer) return;

                const v12Section = group.closest('[data-v12-main]');
                const useV12ImageFallback = v12Section
                    && v12Section.dataset.productId === String(window.productJson.id)
                    && ['Flavor', 'Pack Size'].includes(group.querySelector('[role="radiogroup"]')?.getAttribute('aria-label'));
                const imageRequest = {};
                if (useV12ImageFallback) v12PackImageRequests.set(imageContainer, imageRequest);
                const isCurrent = () => !useV12ImageFallback
                    || v12PackImageRequests.get(imageContainer) === imageRequest;

                let fileName = productSlug;

                // Option 1
                if (optionIndex === 0) {

                    fileName += `_${slugify(input.value)}`;

                }

                // Option 2
                else if (optionIndex === 1) {

                    if (!selectedValues[0]) {
                        imageContainer.innerHTML = '';
                        return;
                    }

                    fileName += `_${slugify(selectedValues[0])}`;
                    fileName += `_${slugify(input.value)}`;

                }

                // Option 3
                else if (optionIndex === 2) {

                    if (!selectedValues[0] || !selectedValues[1]) {
                        imageContainer.innerHTML = '';
                        return;
                    }

                    fileName += `_${slugify(selectedValues[0])}`;
                    fileName += `_${slugify(selectedValues[1])}`;
                    fileName += `_${slugify(input.value)}`;
                }

                updates.push(
                    (async () => {
                        const preferVariantPack = useV12ImageFallback
                            && window.productJson.handle === 'creme-breakfast-biscuits'
                            && group.querySelector('[role="radiogroup"]')?.getAttribute('aria-label') === 'Pack Size';
                        // Versioned Shopify originals prevent stale opaque images from CDN cache.
                        const transparentPackImages = {
                            'fruit_and_grain_bars_fruit_lovers_bundle': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/theo-fruit-lovers-16-pack-oct15.png?v=1792077258',
                            'fruit_and_grain_bars_fruit_lovers_bundle_16_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/theo-fruit-lovers-16-pack-oct15.png?v=1792077258',
                            'fruit_and_grain_bars_fruit_lovers_bundle_32_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/theo-fruit-lovers-32-pack-oct15.png?v=1792076879',

                            "fruit_and_grain_bars_strawberry": "//olyrafoods.com/cdn/shop/files/Olyra_RebrandedWebsiteImages_SingleFlavorHero_FruitandGrainBars_Strawberry.png?v=1773458156&width=1000",
                            "fruit_and_grain_bars_raspberry": "//olyrafoods.com/cdn/shop/files/Olyra_Rebranded_Website_Images_Single_Flavor_Hero_Fruit_and_Grain_Bars_Raspberry.png?v=1773458449&width=1000",
                            "fruit_and_grain_bars_blueberry": "//olyrafoods.com/cdn/shop/files/Olyra_RebrandedWebsiteImages_SingleFlavorHero_FruitandGrainBars_Blueberry.png?v=1773457927&width=1000",
                            "fruit_and_grain_bars_apple_cinnamon": "//olyrafoods.com/cdn/shop/files/Olyra_Rebranded_Website_Images_Single_Flavor_Hero_Fruit_and_Grain_Bars_Apple.png?v=1773457600&width=1000",
                            "breakfast_biscuits_cinnamon_tahini": "https://cdn.shopify.com/s/files/1/0054/0488/5063/files/Olyra_Rebranded-Website-Images_Single-Flavor-Hero_Breakfast-Biscuits_July-24_cinnamon-tahini_800x800.png?v=1765047243",
                            "breakfast_biscuits_fig_anise": "//olyrafoods.com/cdn/shop/files/Olyra_Rebranded-Website-Images_Single-Flavor-Hero_Breakfast-Biscuits_July-24_fig-anise.png?v=1765047255&width=1000",
                            "breakfast_biscuits_hazelnut_carob": "//olyrafoods.com/cdn/shop/files/Olyra_Rebranded-Website-Images_Single-Flavor-Hero_Breakfast-Biscuits_July-24_hazelnut-carob.png?v=1765047203&width=1000",
                            "fruit_and_grain_bars_strawberry_16_pack": "https://olyrafoods.com/cdn/shop/files/09.2025WebsiteBundleImagery_StrawberryFruit_GrainBar_16Pack_transparent.png?v=1790975543",
                            "fruit_and_grain_bars_raspberry_16_pack": "https://olyrafoods.com/cdn/shop/files/09.2025WebsiteBundleImagery_RaspberryFruit_GrainBar_16Pack_transparent.png?v=1790975544",
                            "fruit_and_grain_bars_blueberry_16_pack": "https://olyrafoods.com/cdn/shop/files/09.2025WebsiteBundleImagery_BlueberryFruit_GrainBar_16Pack_transparent.png?v=1790975544",
                            "fruit_and_grain_bars_apple_cinnamon_16_pack": "https://olyrafoods.com/cdn/shop/files/09.2025WebsiteBundleImagery_AppleCinnamonFruit_GrainBar_16Pack_transparent.png?v=1790975544",
                            'fruit_and_grain_bars_blueberry_32_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/fruit_and_grain_bars_blueberry_32_pack.png?v=1791586334',
                            'breakfast_biscuits_fig_anise_32_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/breakfast_biscuits_fig_anise_32_pack.png?v=1791586428',
                            'breakfast_biscuits_cinnamon_tahini_32_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/breakfast_biscuits_cinnamon_tahini_32_pack.png?v=1791586466',
                            'breakfast_biscuits_hazelnut_carob_32_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/breakfast_biscuits_hazelnut_carob_32_pack.png?v=1791586472',
                            'breakfast_biscuits_cinnamon_tahini_16_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/breakfast_biscuits_cinnamon_tahini_16_pack.png?v=1791586513',
                            'breakfast_biscuits_hazelnut_carob_16_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/breakfast_biscuits_hazelnut_carob_16_pack.png?v=1791586513',
                            'fruit_and_grain_bars_apple_cinnamon_32_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/fruit_and_grain_bars_apple_cinnamon_32_pack.png?v=1791586096',
                            'fruit_and_grain_bars_raspberry_32_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/fruit_and_grain_bars_raspberry_32_pack.png?v=1791586368',
                            'fruit_and_grain_bars_strawberry_32_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/fruit_and_grain_bars_strawberry_32_pack.png?v=1791586422',
                            'breakfast_biscuits_fig_anise_16_pack': 'https://cdn.shopify.com/s/files/1/0054/0488/5063/files/breakfast_biscuits_fig_anise_16_pack.png?v=1791586555',
                        };
                        let imageUrl = transparentPackImages[fileName]
                            || (preferVariantPack ? null : await getOptionImageUrl(fileName));
                        if (!isCurrent()) return;

                        // Flavor cards use single-product artwork; pack cards use the exact variant hero.
                        if (!imageUrl && useV12ImageFallback) {
                            const options = selectedValues.map((value, index) => index === optionIndex ? input.value : value);
                            const variant = window.productJson.variants.find((item) =>
                                item.options?.length === options.length
                                && item.options.every((value, index) => value === options[index])
                            );
                            const gallery = variant?.metafields?.variant_images || [];
                            const isFlavor = group.querySelector('[role="radiogroup"]')?.getAttribute('aria-label') === 'Flavor';
                            const singleProductImage = isFlavor
                                ? gallery.find((url) => /single[\s_-]*flavor[\s_-]*hero/i.test(url))
                                : null;
                            imageUrl = singleProductImage || gallery[0]
                                || variant?.featured_image?.src
                                || null;
                        }

                        if (!imageUrl) {
                            imageContainer.innerHTML = '';
                            return;
                        }

                        await setOptionImage(
                            imageContainer,
                            imageUrl,
                            input.value,
                            isCurrent
                        );
                    })()
                );
            });
        });

        await Promise.all(updates);
    }

    function init() {
        updateOptionImages();
    }

    document.addEventListener('variant:changed', function () {
        requestAnimationFrame(() => {
            updateOptionImages();
        });
    });

    document.addEventListener('change', function (event) {
        if (event.target.matches('.productV11ControlsItemChoicesLabelInput')) {
            updateOptionImages();
        }
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();


function waitForElement(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
        const element = document.querySelector(selector);

        if (element) {
            return resolve(element);
        }

        const observer = new MutationObserver(() => {
            const element = document.querySelector(selector);

            if (element) {
                observer.disconnect();
                resolve(element);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        setTimeout(() => {
            observer.disconnect();
            reject(new Error(`Element not found: ${selector}`));
        }, timeout);
    });
}

async function moveElement(elementSelector, targetSelector, position = 'append') {
    try {
        const [element, target] = await Promise.all([
            waitForElement(elementSelector),
            waitForElement(targetSelector)
        ]);

        switch (position) {
            case 'prepend':
                target.prepend(element);
                break;

            case 'before':
                target.parentNode.insertBefore(element, target);
                break;

            case 'after':
                target.parentNode.insertBefore(element, target.nextSibling);
                break;

            case 'replace':
                target.replaceWith(element);
                break;

            case 'append':
            default:
                target.append(element);
        }

        console.log(`Moved ${elementSelector} to ${targetSelector}`);
    } catch (error) {
        console.warn(error.message);
    }
}

// document.addEventListener("DOMContentLoaded", async () => {
//     console.log("DOM fully loaded and parsed");

//     await moveElement(
//         '.shopify-app-block:has([skio-main-product])',
//         '.productV11ATC.ATCTarget',
//         'before'
//     );

//     await waitForElement('.shopify-app-block:has([skio-main-product])');

//     initCustomSubscriptionUI();

//     function initCustomSubscriptionUI() {

//         const skioBlock = document.querySelector(
//             '.shopify-app-block:has([skio-main-product])'
//         );

//         const subscriptionRadio = skioBlock?.querySelector(
//             '[skio-selling-plan-group]'
//         );

//         const oneTimeRadio = skioBlock?.querySelector(
//             '[skio-one-time]'
//         );

//         const frequencySelect = skioBlock?.querySelector(
//             '.skio-frequency'
//         );

//         const atcContainer = document.querySelector(
//             '.productV11ATC.ATCTarget'
//         );

//         // 🚨 IMPORTANT: if no subscription data → exit
//         if (!skioBlock || !frequencySelect || !subscriptionRadio) {
//             console.log("No subscription available → normal ATC mode");

//             // ensure nothing extra exists
//             document.querySelector('.custom-subscription-wrapper')?.remove();
//             document.querySelector('.custom-one-time-link')?.remove();

//             return;
//         }


//         if (
//             !skioBlock ||
//             !subscriptionRadio ||
//             !oneTimeRadio ||
//             !frequencySelect ||
//             !atcContainer
//         ) {
//             console.warn('Skio elements not found');
//             return;
//         }

//         // Default selection = Subscription
//         subscriptionRadio.click();

//         // Hide original Skio UI
//         skioBlock.style.position = 'absolute';
//         skioBlock.style.left = '-9999px';
//         skioBlock.style.opacity = '0';
//         skioBlock.style.pointerEvents = 'none';

//         // Create custom subscription wrapper
//         const customWrapper = document.createElement('div');
//         customWrapper.className = 'custom-subscription-wrapper';

//         // Create buttons from subscription dropdown
//         [...frequencySelect.options].forEach((option, index) => {
//             const btn = document.createElement('button');

//             btn.type = 'button';
//             btn.className = 'custom-subscription-btn';
//             btn.dataset.planId = option.value;
//             btn.textContent = option.textContent.trim();

//             if (index === frequencySelect.selectedIndex) {
//                 btn.classList.add('active');
//             }

//             btn.addEventListener('click', () => {

//                 // Always switch back to subscription
//                 subscriptionRadio.click();

//                 frequencySelect.value = option.value;

//                 frequencySelect.dispatchEvent(
//                     new Event('change', { bubbles: true })
//                 );

//                 document
//                     .querySelectorAll('.custom-subscription-btn')
//                     .forEach(el => el.classList.remove('active'));

//                 btn.classList.add('active');

//                 oneTimeLink.classList.remove('active');
//             });

//             customWrapper.appendChild(btn);
//         });

//         // // Add before ATC
//         // atcContainer.prepend(customWrapper);

//         // One time link
//         const oneTimeLink = document.createElement('span');

//         oneTimeLink.className = 'custom-one-time-link';
//         oneTimeLink.textContent = 'Add One Time Product';

//         oneTimeLink.addEventListener('click', () => {

//             // switch to one-time
//             oneTimeRadio.click();

//             // UI active state
//             oneTimeLink.classList.add('active');

//             document
//                 .querySelectorAll('.custom-subscription-btn')
//                 .forEach(el => el.classList.remove('active'));

//             // 🔥 trigger ATC
//             const atcButton = document.querySelector('.productV11ATC.ATCTarget');

//             if (atcButton) {
//                 atcButton.click();
//             }
//         });

//         // atcContainer.appendChild(oneTimeLink);

//         const atcButton = document.querySelector('.productV11ATC.ATCTarget');

//         if (!atcButton) return;

//         // Above button
//         atcButton.insertAdjacentElement('beforebegin', customWrapper);

//         // Below button
//         atcButton.insertAdjacentElement('afterend', oneTimeLink);

//         // Keep UI synced with Skio
//         function handleSubscriptionTypeChange() {

//             const isSubscription = subscriptionRadio.checked;

//             console.log(
//                 isSubscription
//                     ? 'subscription'
//                     : 'onetime'
//             );

//             if (isSubscription) {
//                 console.log("Sub Product");

//                 oneTimeLink.classList.remove('active');

//                 const activeButton = customWrapper.querySelector(
//                     `[data-plan-id="${frequencySelect.value}"]`
//                 );

//                 document
//                     .querySelectorAll('.custom-subscription-btn')
//                     .forEach(el => el.classList.remove('active'));

//                 activeButton?.classList.add('active');

//             } else {
//                 console.log("non - Sub Product");

//                 oneTimeLink.classList.add('active');

//                 document
//                     .querySelectorAll('.custom-subscription-btn')
//                     .forEach(el => el.classList.remove('active'));
//             }
//         }

//         document.addEventListener('change', (e) => {
//             if (
//                 e.target.matches('[skio-one-time]') ||
//                 e.target.matches('[skio-selling-plan-group]') ||
//                 e.target.matches('.skio-frequency')
//             ) {
//                 handleSubscriptionTypeChange();
//             }
//         });

//         handleSubscriptionTypeChange();
//     }
// });


function waitForElement(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {

        const element = document.querySelector(selector);

        if (element) {
            return resolve(element);
        }

        const observer = new MutationObserver(() => {

            const element = document.querySelector(selector);

            if (element) {
                observer.disconnect();
                resolve(element);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        setTimeout(() => {
            observer.disconnect();
            reject(
                new Error(`Element not found: ${selector}`)
            );
        }, timeout);
    });
}

async function moveElement(
    elementSelector,
    targetSelector,
    position = 'append'
) {
    try {

        const [element, target] = await Promise.all([
            waitForElement(elementSelector),
            waitForElement(targetSelector)
        ]);

        switch (position) {

            case 'prepend':
                target.prepend(element);
                break;

            case 'before':
                target.parentNode.insertBefore(
                    element,
                    target
                );
                break;

            case 'after':
                target.parentNode.insertBefore(
                    element,
                    target.nextSibling
                );
                break;

            case 'replace':
                target.replaceWith(element);
                break;

            case 'append':
            default:
                target.append(element);
        }

    } catch (error) {
        console.warn(error.message);
    }
}


function getSelectedOptions() {
    const groups = document.querySelectorAll(
        '.productV11ControlsItem.option'
    );

    return [...groups].map(group => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value.trim() : null;
    });
}

function getVariantOption(variant, index) {
    return (
        variant.options?.[index] ||
        variant[`option${index + 1}`] ||
        null
    );
}

function findProductVariantByOptions(testSelection) {
    const variants = window.productJson?.variants || [];

    return variants.find(variant => {
        return testSelection.every((selectedValue, index) => {
            if (!selectedValue) return true;

            const variantValue = getVariantOption(variant, index);

            return String(variantValue).trim() === String(selectedValue).trim();
        });
    });
}

function findBadgeVariantByOptions(testSelection) {
    const variants = window.variantIndex || [];

    return variants.find(variant => {
        return testSelection.every((selectedValue, index) => {
            if (!selectedValue) return true;

            const variantValue = getVariantOption(variant, index);

            return String(variantValue).trim() === String(selectedValue).trim();
        });
    });
}

function isVariantSoldOut(variant) {
    if (!variant) return false;

    return (
        variant.available === false ||
        variant.available === 'false'
    );
}

function updateOptionCards() {
    const selected = getSelectedOptions();

    const groups = document.querySelectorAll(
        '.productV11ControlsItem.option'
    );

    groups.forEach((group, optionIndex) => {
        const labels = group.querySelectorAll(
            '.productV11ControlsItemChoicesLabel'
        );
        const optionInput = labels[0]?.querySelector('input');
        const optionName = optionInput?.name?.toLowerCase() || '';
        const optionSupportsBadge = optionName.includes('size');
        const optionSupportsFlavorBadge = optionName.includes('flavor');

        labels.forEach(label => {
            const input = label.querySelector('input');
            if (!input) return;

            const testSelection = [...selected];
            testSelection[optionIndex] = input.value.trim();

            const productVariant = findProductVariantByOptions(testSelection);
            const badgeVariant = findBadgeVariantByOptions(testSelection);

            const soldOut = isVariantSoldOut(productVariant);

            label.classList.toggle('is-sold-out', soldOut);

            // Pack-size badges use custom.option_badge. Flavor badges use the
            // separate custom.flavor_badge field so one value cannot leak into
            // both option groups.
            const badge = optionSupportsFlavorBadge
                ? badgeVariant?.flavorBadge || ''
                : optionSupportsBadge
                    ? badgeVariant?.badge || ''
                    : '';

            let badgeEl = label.querySelector('.js-option-badge');

            if (!badge) {
                badgeEl?.remove();
                return;
            }

            if (!badgeEl) {
                badgeEl = document.createElement('span');
                badgeEl.className = 'badge js-option-badge';
                label.appendChild(badgeEl);
            }

            badgeEl.innerText = badge;
        });
    });
}

document.addEventListener('DOMContentLoaded', updateOptionCards);

document.addEventListener('change', function (event) {
    if (event.target.matches('.productV11ControlsItemChoicesLabelInput, input')) {
        requestAnimationFrame(updateOptionCards);
    }
});

document.addEventListener('variant:changed', function () {
    requestAnimationFrame(updateOptionCards);
});

function getFlavorSlug() {
    const flavorInput = document.querySelector(
        '.productV11ControlsItem.option:first-of-type input:checked'
    );

    if (!flavorInput) return null;

    return flavorInput.value
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
}

function updateSelectedFlavorAttributes() {
    const flavor = getFlavorSlug();
    if (!flavor) return;

    const wrapper = document.querySelector('.productV11Wrapper');

    if (wrapper) {
        wrapper.setAttribute('data-selected-flavor', flavor);
    }

    document
        .querySelectorAll('.productV11ControlsItemChoicesLabelBodyTitle')
        .forEach(title => {
            title.dataset.selectedFlavor = flavor;
        });
}

document.addEventListener('DOMContentLoaded', updateSelectedFlavorAttributes);

document.addEventListener('change', function (event) {
    if (event.target.matches('.productV11ControlsItemChoicesLabelInput')) {
        updateSelectedFlavorAttributes();
    }
});

function updateStickyCtaV2(variantId = null) {
    document.querySelectorAll('.stickyV2Variants').forEach(variantsElement => {
        const section = variantsElement.closest('section');
        if (!section) return;

        let variants;
        try {
            variants = JSON.parse(variantsElement.textContent);
        } catch (error) {
            console.warn('Unable to parse Sticky CTA V2 variants.', error);
            return;
        }

        let activeStickyVariant;

        if (variantId) {
            activeStickyVariant = variants.find(variant => (
                String(variant.id) === String(variantId)
            ));
        }

        if (!activeStickyVariant) {
            const selectedOptions = Array.from(
                document.querySelectorAll('.productV11ControlsItem.option')
            ).map(group => group.querySelector('input:checked')?.value);

            activeStickyVariant = variants.find(variant => (
                variant.options?.every((option, index) => option === selectedOptions[index])
            ));
        }

        if (!activeStickyVariant) return;

        const titleElement = section.querySelector('[data-sticky-v2-title]');
        const sizeElement = section.querySelector('[data-sticky-v2-size]');
        const badgeElement = section.querySelector('[data-sticky-v2-badge]');
        const priceElement = section.querySelector('[data-sticky-v2-price]');
        const compareElement = section.querySelector('[data-sticky-v2-compare]');
        const perElement = section.querySelector('[data-sticky-v2-per]');
        const savingsElement = section.querySelector('[data-sticky-v2-savings]');
        const summaryElement = section.querySelector('[data-sticky-v2-summary]');

        if (titleElement) {
            const baseTitle = titleElement.dataset.baseTitle || '';
            const flavor = activeStickyVariant.flavor || '';
            titleElement.textContent = flavor.toLowerCase().includes(baseTitle.toLowerCase())
                ? flavor
                : `${flavor} ${baseTitle}`.trim();
        }

        if (sizeElement) {
            sizeElement.textContent = activeStickyVariant.size || '';
        }

        if (badgeElement) {
            badgeElement.textContent = activeStickyVariant.badge || '';
        }

        if (summaryElement && activeStickyVariant.highlight_color) {
            summaryElement.style.setProperty(
                '--sticky-v2-accent',
                activeStickyVariant.highlight_color
            );
        }

        if (typeof price !== 'function') return;

        if (priceElement) {
            priceElement.textContent = price(activeStickyVariant.price, true);
        }

        if (compareElement) {
            const showCompare = section.dataset.showCompare === 'true';
            compareElement.textContent = (
                showCompare &&
                activeStickyVariant.compare_at_price > activeStickyVariant.price
            )
                ? price(activeStickyVariant.compare_at_price, true)
                : '';
        }

        if (perElement) {
            const showPricePer = section.dataset.showPricePer === 'true';
            const unitLabel = section.dataset.unitLabel || 'bar';
            perElement.textContent = showPricePer && activeStickyVariant.quantity > 0
                ? `${price(Math.round(activeStickyVariant.price / activeStickyVariant.quantity), true)} / ${unitLabel}`
                : '';
        }

        if (savingsElement) {
            const showSavings = section.dataset.showSavings === 'true';
            savingsElement.textContent = (
                showSavings &&
                activeStickyVariant.compare_at_price > activeStickyVariant.price
            )
                ? `Save ${price(activeStickyVariant.compare_at_price - activeStickyVariant.price, true)}`
                : '';
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    updateStickyCtaV2();
});

document.addEventListener('variant:changed', function (event) {
    updateStickyCtaV2(event.detail?.variant?.id);
});

document.addEventListener('change', function (event) {
    if (event.target.matches('.productV11ControlsItemChoicesLabelInput')) {
        requestAnimationFrame(() => updateStickyCtaV2());
    }
});

document.addEventListener('shopify:section:load', function () {
    updateStickyCtaV2();
});
